"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Loader, CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OrderForm() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return;
}
function OrderFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="text-center py-12">
        <div className="inline-flex items-center justify-center size-16 rounded-full bg-secondary/10 mb-6">
          <CircleCheck className="size-8 text-secondary" />
        </div>
        <h3 className="text-2xl font-semibold mb-4 text-foreground">Поръчката е изпратена!</h3>
        <p className="text-muted-foreground mb-8 max-w-md mx-auto">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="hover-lift">
          Направи нова поръчка
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-6">
        <FormField control={control} name="name" rules={{
        required: "Полето за име е задължително",
        minLength: {
          value: 2,
          message: "Минимум 2 символа"
        },
        maxLength: {
          value: 100,
          message: "Максимум 100 символа"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Име и фамилия</FormLabel>
              <FormControl>
                <Input placeholder="Иван Петров" className="h-11" {...field} />
              </FormControl>
              <FormDescription>Въведете вашето пълно име.</FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" rules={{
        required: "Полето за телефон е задължително",
        pattern: {
          value: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/,
          message: "Моля, въведете валиден телефонен номер"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Телефон за контакт</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+359 88 123 4567" className="h-11" {...field} />
              </FormControl>
              <FormDescription>Ще ви се обадим за потвърждение.</FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Моля, въведете валиден имейл адрес"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Имейл (по желание)</FormLabel>
              <FormControl>
                <Input type="email" placeholder="ivan@example.com" className="h-11" {...field} />
              </FormControl>
              <FormDescription>Изпращаме потвърждение по имейл.</FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="order_details" rules={{
        required: "Моля, опишете вашата поръчка",
        minLength: {
          value: 10,
          message: "Минимум 10 символа"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Детайли на поръчката</FormLabel>
              <FormControl>
                <Textarea placeholder="Опишете какво желаете – ястия, количество, специални изисквания..." className="min-h-32 resize-none" {...field} />
              </FormControl>
              <FormDescription>Колкото по-детайлно, толкова по-бързо ще обработим поръчката.</FormDescription>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="preferred_time" render={({
        field
      }) => <FormItem>
              <FormLabel>Предпочитан час за получаване</FormLabel>
              <FormControl>
                <Input type="text" placeholder="13:30" className="h-11" {...field} />
              </FormControl>
              <FormDescription>Въведете желаното време (чч:мм).</FormDescription>
              <FormMessage />
            </FormItem>} />

        {submitError && <div className="p-4 rounded-lg bg-red-50 border border-red-200">
            <p className="text-red-800 text-sm font-medium">{submitError}</p>
          </div>}

        <Button type="submit" disabled={isSubmitting} className="w-full h-12 text-base font-semibold">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-5" />
              Изпращане...
            </> : 'Изпрати поръчка'}
        </Button>
      </div>
    </Form>;
}